interface TimeSavingsCellProps {
  time: string;
}

export const TimeSavingsCell = ({ time }: TimeSavingsCellProps) => {
  return (
    <div className={"al-px-2 al-text-dark-gray al-text-sm al-font-normal al-leading-5"}>{time}</div>
  );
};
